export abstract class Analytics {
  abstract trackError(error: unknown): void;
  abstract setUser(user: { id?: string; email: string }): void;
  abstract clearUser(): void;
}
